import React from "react";

export function cx(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default function Card({ children, className }) {
  return (
    <div
      className={cx(
        "rounded-2xl border border-neutral-200 bg-white shadow-sm dark:border-neutral-800 dark:bg-neutral-900",
        className
      )}
    >
      {children}
    </div>
  );
}
